// Shared by public links and the Node sitemap generator. Keep the legacy URL format.
const slugify = (value = '') => {
  const slug = String(value)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .replace(/-{2,}/g, '-');

  return slug || 'disco';
};

const getProductSlug = (product = {}) => {
  const storedSlug = typeof product.slug === 'string' ? product.slug.trim() : '';
  if (storedSlug) return storedSlug;

  const id = String(product._id || product.id || '').slice(-6);
  const base = slugify(
    [product.artist, product.title || product.name, product.catalogNumber]
      .filter(Boolean)
      .join(' ')
  );

  return id ? `${base}-${id}` : base;
};

const getProductPath = (product = {}) => `/discos/${getProductSlug(product)}`;

module.exports = { slugify, getProductSlug, getProductPath };
